import React from 'react';
import { Dropover, Text, theme } from '@xometry/xometry_loft';
import { processIdLabels } from '../../../../utils/constants';

const getEventText = (event, orgName) => {
  let member = '';
  let emails: Array<string> = [];
  let invite = '';
  let memberName = '';

  const compileName = (event) => {
    if (event.actorIsStaff) {
      return 'Xometry Staff';
    } else {
      return `${event.actor.firstName} ${event.actor.lastName}`;
    }
  };

  const handleMultipleEmails = () => {
    if (emails.length === 0) return;
    if (emails.length === 1) {
      return emails[0];
    } else {
      return (
        <Dropover alignment={'left'} placement={'top'}>
          <Dropover.Trigger>
            <Text color={theme.colors.blues[100]}>
              {`${emails.length} others`}
            </Text>
          </Dropover.Trigger>
          <Dropover.Content
            fontWeight={theme.fontWeights.regular}
            fontSize="13px"
            padding="8px"
            minWidth={'300px'}
          >
            {emails.join(', ')}
          </Dropover.Content>
        </Dropover>
      );
    }
  };

  const processId: string = event?.eventData?.processId || '';
  const processLabel =
    processIdLabels[processId as keyof typeof processIdLabels];
  const street1 = event?.eventData?.street1 || '';
  const accountNumber = event?.eventData?.accountNumber || '';

  switch (event.type) {
    case 'CREATED':
      return `Created ${orgName}`;
    case 'SENT_INVITATIONS':
      emails = event?.affectedMembers.map((member) => member.email);
      invite = emails.length > 0 ? emails.pop() : 'an unknown user';
      return (
        <>
          {`Sent an invitation to ${invite}`}
          {`${emails.length > 0 ? `  and ` : ''}`}
          {handleMultipleEmails()}
        </>
      );
    case 'CANCELED_INVITATIONS':
      member = event.affectedMembers[0];
      memberName =
        member.firstName !== null
          ? `${member.firstName} ${member.lastName}`
          : member.email;
      return `Canceled the invitation to ${memberName}`;
    case 'ACCEPTED_INVITATION':
      return `${compileName(event)} joined ${orgName}`;
    case 'REJECTED_INVITATION':
      return `${compileName(event)} declined to join ${orgName}`;
    case 'LEFT_ORGANIZATION':
      return `${compileName(event)} left the team`;
    case 'UPDATED_MEMBER_ROLE':
      member = event.affectedMembers[0];
      return `${member.firstName} ${member.lastName}'s role was changed to ${event.eventData.roleName}`;
    case 'REMOVED_MEMBERS':
      member = event.affectedMembers[0];
      return `${member.firstName} ${member.lastName} removed from the team`;
    case 'ARCHIVED':
      return `Archived ${orgName}`;
    case 'UNARCHIVED':
      return `Reactivated ${orgName}`;
    case 'ORGANIZATION_QUOTE_PRESETS_CREATED':
      return `Quote preset created${
        processLabel ? ` for ${processLabel}` : ''
      }`;
    case 'ORGANIZATION_QUOTE_PRESETS_UPDATED':
      return `Quote preset updated${
        processLabel ? ` for ${processLabel}` : ''
      }`;
    case 'ORGANIZATION_QUOTE_PRESETS_DELETED':
      return `Quote preset deleted${
        processLabel ? ` for ${processLabel}` : ''
      }`;
    case 'SHIPPING_ADDRESS_CREATED':
      return `Shipping address ${street1 ? `${street1} ` : ''}has been added`;
    case 'SHIPPING_ADDRESS_UPDATED':
      return `Shipping address ${street1 ? `${street1} ` : ''}has been updated`;
    case 'SHIPPING_ADDRESS_DELETED':
      return `Shipping address ${street1 ? `${street1} ` : ''}has been deleted`;
    case 'SHIPPING_ACCOUNT_CREATED':
      return `Shipping account ${
        accountNumber ? `${accountNumber} ` : ''
      }has been added`;
    case 'SHIPPING_ACCOUNT_UPDATED':
      return `Shipping account ${
        accountNumber ? `${accountNumber} ` : ''
      }has been updated`;
    case 'SHIPPING_ACCOUNT_DELETED':
      return `Shipping account ${
        accountNumber ? `${accountNumber} ` : ''
      }has been deleted`;
    default:
      return event.type;
  }
};
export default getEventText;
